import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { canalAtencion, listadocanales } from '../../utils/Datos';


export const Canales = ({
    className,
    updateState,
    settematicas,
    setcamposDinamicos,
    value,
    name
    }) => {

    const [opciones, setopciones] = useState(null);
    useEffect(() => {
        
        canalAtencion().then((canales)=>{
        if (canales.status) {
            const {datos}=canales;
            setopciones(datos);
        }
        
      })
    }, [])
    
    const handleChange = ((e)=>{
        updateState([
            {
              name: name,
              value: e.target.value,
            },
        ])
        settematicas(null);
        setcamposDinamicos([]);
    })

    return (
        <select
                      name={name}
                      value={value}
                      onChange={handleChange}
                      aria-label="Select a Timezone"
                      data-control="select2"
                      data-placeholder="Select currency"
                      className="form-select  "
            >
            <option value="">Seleccione una opción</option>
            {
                opciones!=null ? 
                opciones.map((element,index)=>{
                    return <option key={`option_${index}`} value={element.id_category_channel}>{element.name_category}</option>
                })
                : <option value="">Seleccione una opción</option>
            }
        </select>
    );
}
